import { Component, Input } from '@angular/core';
import { VwAgency } from '../../interface/agency-list';

@Component({
    selector: 'app-more-details',
    templateUrl: './more-details.component.html',
    styleUrls: ['./more-details.component.scss'],
    standalone: false
})
export class MoreDetailsComponent {
  @Input() moreDetails: VwAgency;
}
